import { View, Text, TouchableOpacity } from "react-native";
import { ReadOnlyProps } from "../../../../utils/templates";
import React, { useState, useEffect } from "react";
import * as Services from "../../../../utils/common";
import { StyleSheet } from "react-native";
import { DataTable, Button, Checkbox, ThemeProvider, useTheme as usePaperTheme } from "react-native-paper";
import statusColorCodes from "../../../../utils/constants/statusColorCodes";
import Spinner from "../../../shared/Spinner";
import { formatValueAsDataType } from "../../../../utils/common";
import Icon from "react-native-vector-icons/FontAwesome5";
import ProductionTrackingForm from "../../../../screens/ChinaTracker/partials/ProductionTrackingForm";
import { ScrollView } from "react-native-gesture-handler";
import { useDispatch, useSelector } from "react-redux";
import { getFactoryOrderDetailsByKey } from "../../../../redux/dispatcher/chinaTrackerDispatcher";
import { useTranslation } from "../../../../utils/useTranslation";
import ChinaTrackerShipmentListModal from "../../../../screens/ChinaTracker/partials/ChinaTrackerShipmentListModal";
import FactoryRunShipmentModal from "../../../../screens/ChinaTracker/partials/ChinaTrackerDirectShipmentModal";
import { useAppTheme } from "../../../../hooks/useAppTheme";


interface Props {
  nestedHeader?: any;
  nestedRows?: Array<any>;
  isNestedDataLoaded?: boolean;
  rowKeyValue?: string;
  itemsPerPage: number;
  isDetail: boolean;
  isDisplayTimeWithDate?: boolean;
  setModalVisible: (event: any) => void;
  handleRowClick: (event: any) => void;
  setSelected: (event: any) => void;
  nestedColumnsToNotHaveThousandSeparator?: Array<string>;
  handleNestedSortColumn?: (
    columnKey: string,
    columnParentIdentifier: string,
  ) => void;
  disableHeader?: boolean;
  operationActions?: (order: any, action: string) => void;
  onFormSubmit?: (formData: any) => void;
  onFormUpdate?: (formData: any) => void;
  fieldTypes?: Record<string, string>;
  currentRow: any;
  prefixRow: any;
}

export const ChinaNestedDataTableWithPagination2: React.FC<
  ReadOnlyProps<Props>
> = ({
  nestedHeader,
  nestedRows,
  isNestedDataLoaded = true,
  rowKeyValue,
  itemsPerPage,
  nestedColumnsToNotHaveThousandSeparator,
  handleNestedSortColumn,
  disableHeader,
  currentRow,
  fieldTypes = {},
  prefixRow,
  operationActions,
}: ReadOnlyProps<Props>) => {
    const { colors: themeColors } = useAppTheme();
    const styles = createStyles(themeColors);
  const paperTheme = usePaperTheme();
  const paginationTheme = { ...paperTheme, colors: { ...paperTheme.colors, text: themeColors.text, onSurface: themeColors.text, onSurfaceVariant: themeColors.text } };
    const [nestedPage, setNestedPage] = useState<number>(0);
    const [_nestedItemsPerPage] = useState<number>(itemsPerPage);
    const [formData, setFormData] = useState<any>({});
    const [isFormMode, setIsFormMode] = useState<boolean>(false);
    const [shipmentsViewModal, setShipmentsViewModal] = useState<boolean>(false);
    const [shipmentViewRow, setShipmentViewRow] = useState<any>();

    const [formModeActionNumber, setFormModeActionNumber] = useState<
      number | null
    >(null);
    const [editingRowIndex, setEditingRowIndex] = useState<number | null>(null);
    const dispatch = useDispatch<any>();
    const { t } = useTranslation();

    const { loadingRunOrders, runOrders } = useSelector(
      (state: any) => state.chinaTracker,
    );

    const handleViewShipments = (row: any) => {
      setShipmentViewRow(row);
      setShipmentsViewModal(true);
    };

    // Default field types if not provided
    const defaultFieldTypes: Record<string, string> = {
      date_created: "date",
      date: "date",
      created_at: "date",
      updated_at: "date",
      createdAt: "date",
      ...fieldTypes,
    };

    useEffect(() => {
      if (currentRow) {
        dispatch(getFactoryOrderDetailsByKey(currentRow)).unwrap();
      }
    }, [currentRow]);

    useEffect(() => {
      // Initialize form data with empty values based on headers
      if (!runOrders || runOrders.length === 0) {
        const initialFormData: any = {};
        if (nestedHeader) {
          Object.keys(nestedHeader).forEach((key) => {
            if (defaultFieldTypes[key] === "date") {
              initialFormData[key] = new Date();
            } else {
              initialFormData[key] = "";
            }
          });
        }
        setFormData(initialFormData);
      }
    }, [runOrders, nestedHeader, loadingRunOrders]);

    // Get the current rows to display based on view mode
    const displayRows = runOrders;
    const displayHeader = nestedHeader;

    const pagedRows = displayRows?.slice(
      nestedPage * _nestedItemsPerPage,
      (nestedPage + 1) * _nestedItemsPerPage,
    );

    const onCancel = () => {
      setIsFormMode(false);
    };

    const [modalOpen, setModalOpen] = useState<boolean>();
    const onCloseEnquiry = () => {
      setModalOpen(false);
      // Refresh the data after modal closes to show the new direct shipment
      if (currentRow) {
        dispatch(getFactoryOrderDetailsByKey(currentRow)).unwrap();
      }
    };

    if (isFormMode) {
      return (
        <ProductionTrackingForm
          onCancel={onCancel}
          editingRowIndex={editingRowIndex}
          initialData={pagedRows}
          isFormMode
          currentRow={currentRow}
          isEditMode={pagedRows?.length === 0 ? false : true}
          formModeActionNumber={formModeActionNumber}
          prefixRow={prefixRow}
        />
      );
    }

    return (
      <>
        {modalOpen && (
          <FactoryRunShipmentModal
            chinaOrder={prefixRow}
            onClose={onCloseEnquiry}
            visible={modalOpen}
            setIsFormMode={setIsFormMode}
          />
        )}
        <ScrollView
          horizontal
          contentContainerStyle={{
            paddingVertical: 8,
            paddingHorizontal: 12,
          }}
          style={[styles.collapsableView, { padding: 0 }]}
        >
          {shipmentsViewModal && shipmentViewRow && (
            <ChinaTrackerShipmentListModal
              onClose={() => setShipmentsViewModal(false)}
              order={shipmentViewRow}
              visible={shipmentsViewModal}
              prefixRow={prefixRow}
            />
          )}

          <DataTable style={{ padding: 0 }}>
            {!disableHeader && displayHeader && (
              <DataTable.Header>
                {Object.keys(displayHeader).map((key) => {
                  return (
                    <DataTable.Title
                      style={{
                        justifyContent:
                          displayHeader[key].justifyContent ?? "flex-start",
                        flex: 1,
                        minWidth: key === "actions" ? 280 : 200,
                      }}
                      key={`${Services.makeid(10)}_${key}`}
                    >
                      <View style={{ width: key === "actions" ? 280 : 200 }}>
                        <Text
                          style={{
                            fontSize: 13,
                            width: "100%",
                            textAlign: displayHeader[key].textAlign,
                            fontWeight: "bold",
                            color: themeColors.text,
                          }}
                        >
                          {displayHeader[key].name} &nbsp;&nbsp;
                          {displayHeader[key].isSort &&
                            displayRows &&
                            displayRows.length > 1 && (
                              <TouchableOpacity
                                onPress={() =>
                                  handleNestedSortColumn?.(
                                    key,
                                    displayRows[0][rowKeyValue as string],
                                  )
                                }
                              >
                                <Icon
                                  name={
                                    displayHeader[key].sortDirection === "asc"
                                      ? "sort-alpha-down"
                                      : "sort-alpha-up"
                                  }
                                  size={13}
                                  color={themeColors.text}
                                />
                              </TouchableOpacity>
                            )}
                        </Text>
                      </View>
                    </DataTable.Title>
                  );
                })}
              </DataTable.Header>
            )}

            {loadingRunOrders ? (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 12,
                }}
              >
                <Spinner size="small" color="#56B7FD" />
                <Text style={{ marginLeft: 8, color: "#56B7FD", fontSize: 14 }}>
                  {t("loading")}
                </Text>
              </View>
            ) : !isNestedDataLoaded ? (
              (pagedRows as any[]).length > 0 ? (
                <>
                  {pagedRows?.map((_row, index) => {
                    return (
                      <DataTable.Row
                        key={`${Services.makeid(10)}_${_row[rowKeyValue as string]
                          }`}
                        style={{
                          borderColor: themeColors.surfaceSubtle,
                          borderLeftWidth: 1,
                          borderRightWidth: 1,
                          borderBottomWidth: 1,
                          backgroundColor: _row?.interrupted ? "#FFD1D0" : themeColors.surface,
                        }}
                      >
                        {Object.keys(displayHeader).map((_header) => {
                          const value = _row[_header];

                          // if runOrder === 0 → display '-' for non-essential columns
                          if (
                            (_row.runOrder === 0 || _row.directShipment) &&
                            _header !== "runOrder" &&
                            _header !== "actions" &&
                            !["directShipment"].includes(_header)
                          ) {
                            return (
                              <View
                                key={Services.makeid(10)}
                                style={{
                                  flex: 1,
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Text
                                  selectable={true}
                                  style={{
                                    fontSize: 12,
                                    width: "100%",
                                    textAlign: displayHeader[_header]?.textAlign || "left",
                                    color: "#999",
                                  }}
                                >
                                  -
                                </Text>
                              </View>
                            );
                          }

                          const isCheckboxField = [
                            "labelOrder",
                            "directShipment",
                            "soakarPad",
                          ].includes(_header);
                          const isDateField = [
                            "planStartDay",
                            "actualStartDay",
                            "ESTCompletionDate",
                            "ESTPackDate",
                            "ETD",
                            "ETA",
                            "ExpectedArrival",
                            "actualCompletionDate",
                            "shippingDeadline",
                            "shipDate",
                            "estimatedDelivery",
                          ].includes(_header);

                          return (
                            <View
                              style={{
                                flex: 1,
                                minWidth: ["actions"].includes(_header) ? 280 : 200,
                                borderColor: themeColors.surface,
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              key={Services.makeid(10)}
                            >
                              {["status", "ship_status", "orderStatus"].includes(
                                _header,
                              ) ? (
                                <TouchableOpacity
                                  style={{
                                    backgroundColor:
                                      statusColorCodes[value] || themeColors.border,
                                    paddingHorizontal: 12,
                                    paddingVertical: 8,
                                    borderRadius: 16,
                                    minWidth: 100,
                                    alignItems: "center",
                                  }}
                                  onPress={() => {
                                    console.log(
                                      `${t("submit")}:`,
                                      _row.OrderNumber,
                                    );
                                  }}
                                >
                                  <Text
                                    style={{ color: themeColors.surface, fontWeight: "600" }}
                                  >
                                    {t("submit")}
                                  </Text>
                                </TouchableOpacity>
                              ) : isCheckboxField ? (
                                <View style={{ width: "100%" }}>
                                  <Checkbox
                        uncheckedColor={themeColors.textSecondary}
                        color="#56B7FD"
                                    status={value ? "checked" : "unchecked"}
                                    onPress={() => { }}
                                  />
                                </View>
                              ) : isDateField ? (
                                <Text
                                  selectable={true}
                                  style={{
                                    fontSize: 12,
                                    width: "100%",
                                    textAlign: displayHeader[_header]?.textAlign || "left",
                                    userSelect: "text",
                                    color: themeColors.text,
                                  } as any}
                                >
                                  {Services.formatLocalDate(value)}
                                </Text>
                              ) : ["runOrder"].includes(_header) ? (
                                <Text
                                  selectable={true}
                                  style={{
                                    fontSize: 12,
                                    width: "100%",
                                    textAlign: displayHeader[_header]?.textAlign || "left",
                                    userSelect: "text",
                                    color: themeColors.text,
                                  } as any}
                                >
                                  {value === 0
                                    ? `${t("run")} -`
                                    : `${t("run")} ${value}`}
                                </Text>
                              ) : ["actions"].includes(_header) ? (
                                <View
                                  style={{
                                    flexDirection: "row",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: 8,
                                    paddingVertical: 8,
                                    width: "100%",
                                  }}
                                >
                                  <>
                                    {!(
                                      // NEW CONDITIONS ↓
                                      (
                                        _row.runOrder === 0 ||
                                        _row.directShipment ||
                                        // EXISTING CONDITION ↓
                                        (pagedRows.length === 1 &&
                                          pagedRows[0].runOrder === 0)
                                      )
                                    ) && (
                                        <>
                                          {prefixRow?.OrderStatus !== "Cancelled" && (
                                            <TouchableOpacity
                                              style={[
                                                styles.floatingAddButton2,
                                                _row?.interrupted &&
                                                styles.interruptedButton,
                                              ]}
                                              onPress={() =>
                                                operationActions &&
                                                operationActions(_row, "interrupt")
                                              }
                                              activeOpacity={0.8}
                                            >
                                              <Icon
                                                name="exclamation-circle"
                                                size={16}
                                                color={
                                                  _row?.interrupted
                                                    ? "#FF3B30"
                                                    : themeColors.text
                                                }
                                              />
                                            </TouchableOpacity>
                                          )}

                                          {prefixRow?.OrderStatus !== "Cancelled" && (
                                            <TouchableOpacity
                                              style={[styles.floatingAddButton]}
                                              onPress={() => {
                                                setIsFormMode(true);
                                                setFormModeActionNumber(index);
                                              }}
                                            >
                                              <Text style={[styles.buttonText2]}>
                                                {pagedRows.length > 0
                                                  ? t("resubmit")
                                                  : t("submit")}
                                              </Text>
                                            </TouchableOpacity>
                                          )}
                                        </>
                                      )}

                                    <TouchableOpacity
                                      style={[
                                        styles.floatingAddButton,
                                        { backgroundColor: "#36a64f" },
                                      ]}
                                      onPress={() => handleViewShipments(_row)}
                                    >
                                      <Text style={styles.buttonText2}>
                                        {t("shipments")}
                                      </Text>
                                    </TouchableOpacity>
                                  </>
                                </View>
                              ) : (
                                <Text
                                  selectable={true}
                                  style={{
                                    fontSize: 12,
                                    width: "100%",
                                    textAlign: displayHeader[_header]?.textAlign || "left",
                                    userSelect: "text",
                                    color: themeColors.text,
                                  } as any}
                                >
                                  {nestedColumnsToNotHaveThousandSeparator?.includes(
                                    displayHeader[_header].name,
                                  )
                                    ? value
                                    : displayHeader[_header].name.includes("Uom1")
                                      ? `${formatValueAsDataType(value)} (${_row["InvntryUom"]
                                      })`
                                      : displayHeader[_header].name.includes("Uom2")
                                        ? `${formatValueAsDataType(value)} (${_row["Uom2"]
                                        })`
                                        : formatValueAsDataType(value)}
                                </Text>
                              )}
                            </View>
                          );
                        })}
                      </DataTable.Row>
                    );
                  })}
                  <View
                    style={[
                      styles.noDataBanner2,
                      {
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    ]}
                  >
                    {prefixRow?.OrderStatus !== "Cancelled" && (
                      <Button
                        style={[styles.addNewButton, { marginRight: 10 }]} // smaller gap
                        onPress={() => setIsFormMode(true)}
                      >
                        <Text style={styles.addButtonText}>
                          <Icon name="plus" size={15} color={themeColors.surface} /> {t("addNew")}
                        </Text>
                      </Button>
                    )}

                    {prefixRow?.OrderStatus !== "Cancelled" && (
                      <Button
                        style={styles.addNewButton}
                        onPress={() => setModalOpen(true)}
                      >
                        <Text style={styles.addButtonText}>
                          <Icon name="truck" size={15} color={themeColors.surface} />{" "}
                          {t("addDirectShipment")}
                        </Text>
                      </Button>
                    )}
                  </View>
                </>
              ) : (
                <View
                  style={[
                    styles.noDataBanner,
                    {
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    },
                  ]}
                >
                  {prefixRow?.OrderStatus !== "Cancelled" && (
                    <Button
                      style={[styles.addNewButton, { marginRight: 10 }]} // smaller gap
                      onPress={() => setIsFormMode(true)}
                    >
                      <Text style={styles.addButtonText}>
                        <Icon name="plus" size={15} color={themeColors.surface} /> {t("addNew")}
                      </Text>
                    </Button>
                  )}

                  {prefixRow?.OrderStatus !== "Cancelled" && (
                    <Button
                      style={styles.addNewButton}
                      onPress={() => setModalOpen(true)}
                    >
                      <Text style={styles.addButtonText}>
                        <Icon name="truck" size={15} color={themeColors.surface} />{" "}
                        {t("addDirectShipment")}
                      </Text>
                    </Button>
                  )}
                </View>
              )
            ) : (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 12,
                }}
              >
                <Spinner size="small" color="#56B7FD" />
                <Text style={{ marginLeft: 8, color: "#56B7FD", fontSize: 14 }}>
                  {t("loading")}
                </Text>
              </View>
            )}
          </DataTable>
        </ScrollView>
      </>
    );
  };

function createStyles(colors: any) {
  return StyleSheet.create({
  collapsableView: {
    flex: 1,
    borderStyle: "solid",
    borderColor: "rgba(47, 149, 220, 0.5)",
    borderWidth: 1,
    position: "relative",
  },
  noDataBanner2: {
    margin: "1%",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  noDataBanner: {
    margin: "2%",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  orderStatusDate: {
    fontSize: 12,
    textAlign: "center",
    color: "#C0BCBC",
  },
  actionsIcons: {
    paddingHorizontal: 8,
  },
  actionsIconsMobile: {
    paddingHorizontal: 2,
  },
  menuOptionContainer: {
    flex: 1,
    marginHorizontal: 2,
  },
  formScrollContainer: {
    padding: 15,
  },
  formRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 15,
  },
  formFieldHorizontal: {
    flex: 1,
    marginHorizontal: 5,
  },
  formLabel: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 5,
  },
  formInput: {
    borderWidth: 1,
    borderColor: "rgba(47, 149, 220, 0.5)",
    borderRadius: 5,
    padding: 10,
    fontSize: 14,
  },
  datePickerInput: {
    backgroundColor: "transparent",
  },
  formButtonContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 20,
    marginBottom: 10,
  },
  formButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
    marginLeft: 10,
  },
  cancelButton: {
    backgroundColor: "#C0BCBC",
  },
  submitButton: {
    backgroundColor: "rgba(47, 149, 220, 1)",
  },
  buttonText: {
    color: colors.surface,
    fontWeight: "bold",
    fontSize: 14,
  },
  buttonText2: {
    color: colors.surface,
    fontWeight: "700",
    fontSize: 10,
  },
  addNewButton: {
    backgroundColor: "rgba(47, 149, 220, 1)",
    // paddingVertical: 10,
    // paddingHorizontal: 20,
    borderRadius: 5,
  },
  addButtonText: {
    color: colors.surface,
    fontWeight: "bold",
    fontSize: 14,
  },
  floatingAddButton: {
    marginTop: 10,
    backgroundColor: "#56B7FD",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 4,
    paddingHorizontal: 12,
    borderRadius: 5,
    minWidth: 80,
    height: 28,
  },
  floatingAddButton2: {
    marginTop: 10,
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: 16,

    // Floating effect
    elevation: 4, // Android
    shadowColor: colors.text, // iOS
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3,
  },

  interruptedButton: {
    backgroundColor: "#FFE5E5",
  },

  backButtonContainer: {
    marginBottom: 10,
  },
  backButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#081D2C",
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 5,
    gap: 8,
    alignSelf: "flex-start",
  },
  backButtonText: {
    color: colors.surface,
    fontWeight: "600",
    fontSize: 12,
  },
});
}
